import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInterviewDetailState, IInterviewScheduleState, IUpdateInterviewState, ICancelInterviewState, IApiResponse } from './types';
import { getInterviewDetail, scheduleInterview, updateInterview, cancelInterview } from './actions';

const initialScheduleState: IInterviewScheduleState = {
  loading: false,
  data: null,
  error: null,
};

const initialDetailState: IInterviewDetailState = {
  loading: false,
  data: null,
  error: null,
};

const initialUpdateInterviewState: IUpdateInterviewState = {
  loading: false,
  data: null,
  error: null,
};

const initialCancelInterviewState: ICancelInterviewState = {
  loading: false,
  data: null,
  error: null,
};

export const scheduleInterviewSlice = createSlice({
  name: 'scheduleInterview',
  initialState: initialScheduleState,
  reducers: {
    clearScheduledInterviewMessage: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(scheduleInterview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(scheduleInterview.fulfilled, (state, action: PayloadAction<IApiResponse>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(scheduleInterview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearScheduledInterviewMessage } = scheduleInterviewSlice.actions;
export const scheduleInterviewMessageReducer = scheduleInterviewSlice.reducer;

export const getInterviewDetailSlice = createSlice({
  name: 'getInterviewDetail',
  initialState: initialDetailState,
  reducers: {
    clearInterviewDetail: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInterviewDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInterviewDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getInterviewDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearInterviewDetail } = getInterviewDetailSlice.actions;
export const getInterviewDetailReducer = getInterviewDetailSlice.reducer;


export const updateInterviewSlice = createSlice({
  name: 'updateInterview',
  initialState: initialUpdateInterviewState,
  reducers: {
    clearUpdateInterviewMessage: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateInterview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInterview.fulfilled, (state, action: PayloadAction<IApiResponse>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateInterview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearUpdateInterviewMessage } = updateInterviewSlice.actions;
export const updateInterviewReducer = updateInterviewSlice.reducer;

export const cancelInterviewSlice = createSlice({
  name: 'cancelInterview',
  initialState: initialCancelInterviewState,
  reducers: {
    clearCancelInterviewMessage: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cancelInterview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelInterview.fulfilled, (state, action: PayloadAction<IApiResponse>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(cancelInterview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearCancelInterviewMessage } = cancelInterviewSlice.actions;
export const cancelInterviewReducer = cancelInterviewSlice.reducer;

